<template>
  <dropdown
    :disabled="model === 'admin'"
    :items="roles"
    :label="$t('user_type')"
    item-text="text"
    item-value="val"
    :rules="[rules.required]"
    v-model="model"
    required
    dense
  />
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasEmployeeTypes from "@/mixins/hasEmployeeTypes";
import deliveryUsersContext from "@/mixins/deliveryUsersContext";

export default {
  mixins: [hasModel, hasValidation, hasEmployeeTypes, deliveryUsersContext],
  props: {
    company: {
      type: Object,
      required: false,
    },
  },
  computed: {
    restaurantRoles() {
      return [
        { text: this.$t("restaurant"), val: "restaurant" },
        { text: this.$t("qr_scanner_division"), val: "payment" },
        { text: this.$t("reports_worker_orders"), val: "report" },
        {
          text: this.$t("reports_guest_orders"),
          val: "report_guest",
        },
        { text: this.$t("stock"), val: "warehouse" },
        { text: this.$t("table"), val: "table" },
        {
          text: this.$t("worker_more_restaurants"),
          val: "worker_more_restaurants",
        },
      ];
    },
    companyRoles() {
      return [
        { text: this.$t("worker"), val: "customer" },
        { text: this.$t("company_admin"), val: "company" },
        { text: this.$t("meal_reception_delivery"), val: "recipient" },
        { text: this.$t("guest"), val: "guest" },
        { text: this.$t("table"), val: "table" },
        {
          text: this.$t("worker_more_restaurants"),
          val: "worker_more_restaurants",
        },
      ];
    },
    deliveryRoles() {
      return [
        { text: this.$t("delivery_person"), val: "dostava" },
        { text: this.$t("admin_delivery"), val: "admin_delivery" },
      ];
    },
    roles() {
      if (this.$route.name === "restoran-id-korisnici") return this.restaurantRoles;
      if (this.isDeliveryUsersContext) return this.deliveryRoles;
      const company = this.company || this.$store.state.company;
      return this.getEligibleEmployeeTypes(company?.contract);
    },
  },
};
</script>
